// extracted by mini-css-extract-plugin
module.exports = {"moreInfoButton":"styles__moreInfoButton--zhd8s","moreInfoIcon":"styles__moreInfoIcon--2zHMo","icon":"styles__icon--isQKS","moreInfoSection":"styles__moreInfoSection--3j69U"};